import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13.062 7.809l3.201 0.306c-0.493 2.396-1.020 4.792-1.583 7.188l-2.076 8.637-2.99 0.279-0.281 1.114h9.323l0.281-1.114-3.201-0.307c0.493-2.396 1.020-4.82 1.583-7.216l2.041-8.609 3.025-0.279 0.281-1.142h-9.323l-0.281 1.142z"
	})
});
export { SvgIconItalic as ReactComponent };
